import React from 'react'

const MainStaticTitle = ({ containerObject, templateName, contentId, dataZone }) => {
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`} >
      <h2 className='static-page-title mb-3 mt-2' dangerouslySetInnerHTML={{ __html: containerObject.attributes.staticTitle }}></h2>
    </div>
  )
}

export default MainStaticTitle